import { render, staticRenderFns } from "./SweetSpotReport.vue?vue&type=template&id=6b0becf0&scoped=true"
import script from "./SweetSpotReport.vue?vue&type=script&lang=js"
export * from "./SweetSpotReport.vue?vue&type=script&lang=js"
import style0 from "./SweetSpotReport.vue?vue&type=style&index=0&id=6b0becf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0becf0",
  null
  
)

export default component.exports